import { Component, Input } from '@angular/core';

@Component({
  selector: 'embed-video',
  templateUrl: './embed-video.component.html',
  styleUrls: ['./embed-video.component.scss'],
  standalone: false
})
export class EmbedVideoComponent {
  @Input() src: string;
  @Input() frame = true;
  constructor() {}
}
